export default __webpack_public_path__ + "static/media/FleuretteLovelace.6ff22003.png";